export const MAX_POST_IMAGES = 10;
export const MAX_POST_IMAGE_BYTES = 5 * 1024 * 1024;
export const MAX_POST_VIDEO_BYTES = 50 * 1024 * 1024;
export const isPostVideo = (url) => /\.(mp4|webm|mov|m4v)(?:[?#]|$)/i.test(url || '');
export const postImageUrls = (media) => (Array.isArray(media) ? media : [])
  .map((item) => typeof item === 'string' ? item : item?.url || item?.src)
  .filter((url) => url && !isPostVideo(url));

export const validatePostFiles = (existing, files) => {
  const combined = [...existing, ...files];
  if (combined.length > MAX_POST_IMAGES) return `Choose up to ${MAX_POST_IMAGES} photos.`;
  if (combined.some((file) => file.type?.startsWith('video/')) && combined.length > 1) {
    return 'Choose photos or one video. Remove the current media before switching.';
  }
  for (const file of files) {
    if (!['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'video/mp4', 'video/webm', 'video/quicktime'].includes(file.type)) {
      return 'Choose JPEG, PNG, GIF or WebP photos, or an MP4, WebM or MOV video.';
    }
    const video = file.type.startsWith('video/');
    if (file.size > (video ? MAX_POST_VIDEO_BYTES : MAX_POST_IMAGE_BYTES)) {
      return `${file.name}: maximum size is ${video ? 50 : 5} MB.`;
    }
  }
  return null;
};

export const buildPostShareUrl = (postId, origin = globalThis.location?.origin || 'https://www.liquidspirit.org') => {
  const baseOrigin = origin || 'https://www.liquidspirit.org';
  const host = new URL(baseOrigin).hostname;
  const base = ['liquidspirit.org', 'www.liquidspirit.org', 'app.liquidspirit.org'].includes(host)
    ? 'https://www.liquidspirit.org' : baseOrigin;
  return `${base}/posts/${encodeURIComponent(postId)}`;
};
